export default __webpack_public_path__ + "static/media/2.3654a1b6.jpg";